import fetchInterceptor from '@common/store/middleware/fetchInterceptor';
import { toBusinessServiceEndpoint } from '@store/entities/businesses/stateUtils/toBusinessServiceEndpoint';
import { useAppDispatch } from '@store/hooks';
import { store } from '@store/store';

export function useBusinessServiceFetch() {
  const dispatch = useAppDispatch();
  const interceptedFetch = fetchInterceptor(fetch, dispatch, store.getState);

  return {
    fetch: <ReturnType>(path: string, options: RequestInit) => {
      return interceptedFetch(
        `${toBusinessServiceEndpoint(store.getState)}/${path}`,
        options
      ) as Promise<ReturnType>;
    }
  };
}
